import { Injectable, inject } from "@angular/core";
import { Router, NavigationExtras, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";

export interface RisrNavigationExtras extends NavigationExtras {
    previousRoute?: string;
}

@Injectable({ providedIn: 'root' })
export class RouterHelperService {

    private router = inject(Router);
    private state: any;
    private previousRoute: string | undefined;

    getRootSnapshot() {
        let root = this.router.routerState.snapshot.root;
        while (root.firstChild) {
            root = root.firstChild;
        }
        return root;
    }
    getParams() {
        let root = this.getRootSnapshot();
        return root.params;
    }

    getState() {
        let root = this.getRootSnapshot();
        return root.data.state;
    }

    url() {
        return this.router.routerState.snapshot.url;
    }

    getPath() {
        let path: string[] = [];
        let root = this.router.routerState.snapshot.root;
        if (root.routeConfig?.path) {
            path.push(root.routeConfig.path);
        }
        while (root.firstChild) {
            root = root.firstChild;
            if (root.routeConfig?.path) {
                path.push(root.routeConfig.path);
            }
        }
        return path.join('/');
    }

    setState(state: any) {
        this.state = state;
    }

    setPreviousRoute(route: string) {
        console.log('Setting previous route to', route);
        this.previousRoute = route;
    }

    popState() {
        const state = this.state || {};
        this.state = undefined;
        return state;
    }

    navigate(route: any[], params: RisrNavigationExtras = {}) {
        if (params.state) {
            const state = params.state;
            delete params.state;
            this.setState(state);
        }
        if (params.previousRoute) {
            this.previousRoute = params.previousRoute;
        }
        return this.router.navigate(route, params);
    }

    /**
     * Navigate back in the browser's history
     */
    back(defaultRoute: any[]): void {
        if (this.previousRoute) {
            console.log('Navigating back to', this.previousRoute);
            const previousRoute = this.previousRoute;
            this.previousRoute = undefined;
            this.router.navigateByUrl(previousRoute);
        } else if (defaultRoute) {
            console.log('Navigating to default route', defaultRoute);
            this.router.navigate(defaultRoute);
        }
    }

    onSuccess(fn: Function) {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
        ).subscribe((event: NavigationEnd) => {
            fn(event);
        });
    }
}
